<template>
  <div class="row">
    <div class="col-md-3">
      <b-form inline>
        <label class="mr-sm-2">Start Date</label>
        <date-picker v-model="startDate" :config="dateOptions" placeholder="Start Date"></date-picker>
      </b-form>
    </div>
    <div class="col-md-3 mt-3 mt-md-0">
      <b-form inline>
        <label class="mr-sm-2">End Date</label>
        <date-picker v-model="endDate" :config="dateOptions" placeholder="End Date"></date-picker>
      </b-form>
    </div>
    <div class="col-md-3 mt-3 mt-md-0">
      <b-button :variant="'primary'" type="button" @click="search(startDate, endDate)">Search</b-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'report-date-range',
    data() {
      return {
        startDate: null,
        endDate: null,
        dateOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        }
      }
    },
    props: {
      search: Function
      // startDate: {
      //   type: Date,
      //   default: null,
      //   required: false
      // },
      // endDate: {
      //   type: Date,
      //   default: null,
      //   required: false
      // }
    }
  }
</script>
